import { call, put, select, takeEvery } from 'redux-saga/effects';
import { SET_SEARCH, GET_SEARCH_LIST, SET_SEARCH_DATA, UPDATE_SEARCH_CONDITIONS, SHOW_SELECT_TEMPLATE_BOX, SET_SELECT_TEMPLATE_BOX } from 'store/key';
import { produce } from 'utility/general';
import API from 'api/call';
import { safeSaga } from 'store';
import { basicDefaultFormData } from 'hooks/search/searchData';
import { BASIC } from 'hooks/search/searchData';

const initialState = {
    isLoading: false,
    forceErrorDisplay: false,
    docType: '',
    conditionsRequests: [],
    applicationRows: [],
    postApprovalRows: [],
    isApplication: true,
    
    downloadData: {},
    basicFormData: basicDefaultFormData,
    
    applicationPage: {
        pageSize: 10,
        page: 1,
        sort: 'updateDtm',
        isDesc: true,
        total: 0,
    },
    postApprovalPage: {
        pageSize: 10,
        page: 1,
        sort: 'updateDtm',
        isDesc: true,
        total: 0,
    },
    
    filterKeyword: '',
    selectedRows: [],
    advancedFormData: {},
    showCriteria: true,
    isFullViewShow: false,
    expandCount: 0,
    searchType: BASIC,
    selectTemplateBox: {
        isShow: false,
        handleConfirm: () => {},
    }
};

function* getSearchList(action) {
    const { search } = yield select();
    const {
        role = '',
        page = 1,
        pageSize = 10,
        docType = search.docType,
        conditionsRequests = search.conditionsRequests,
        sort = 'updateDtm',
        isDesc = true,
    } = action.payload;

    yield put({
        type: SET_SEARCH,
        payload: {
            isLoading: true,
        },
    });
    const data = {
        role: role,
        page: page,
        pageSize: pageSize,
        docType: docType,
        conditionsRequests: conditionsRequests,
        sort: sort,
        isDesc: isDesc,
    };
    try {
        const res = yield call(API.search.getSearchList, data);
        const response = res.data?.result?.result ?? [];

        const result = response.map((item) => {
            if (item.statusId === 0) {
                item.disabledItemCheckbox = true;
            };
            return item;
        });

        if (search.isApplication) {
            /** set application data */
            search.applicationRows = result;
            search.applicationPage = {
                total: res.data?.result?.total,
                page: res.data?.result?.page,
                pageSize: res.data?.result?.pageSize,
            }
        } else {
            /** set post approval data */
            search.postApprovalRows = result;
            search.postApprovalPage = {
                total: res.data?.result?.total,
                page: res.data?.result?.page,
                pageSize: res.data?.result?.pageSize,
            }
        }

        yield put({
            type: SET_SEARCH,
            payload: search,
        });
    } catch (err) {
        console.log(err);
    }

    yield put({
        type: SET_SEARCH,
        payload: {
            isLoading: false,
        },
    });
}

function* setSearchData(action) {
    const { search } = yield select();
    if (action.payload === undefined) return;

    for (let key in action.payload) {
        search[key] = action.payload[key];
    }
    yield put({
        type: SET_SEARCH,
        payload: search,
    });
}

function* updateSearchConditions(action) {
    const { search } = yield select();
    if (action.payload === undefined) return;
    const { type = 'add', searchItem } = action.payload;
    const index = search.conditionsRequests.findIndex((item) => item.fieldName === searchItem?.fieldName && item.operatorType === searchItem?.operatorType);
    switch (type) {
        case 'add':
            if (searchItem.fieldName === 'docType') {
                /** update docType */
                search.docType = searchItem.fieldValue;
            } else {
                /** update conditionsRequests: Add item */
                if (index !== -1) {
                    search.conditionsRequests[index] = searchItem;
                } else {
                    search.conditionsRequests.push(searchItem);
                }
            }
            break;
        case 'delete':
            /** update conditionsRequests: delete item */
            if (index !== -1) {
                search.conditionsRequests.splice(index, 1);
            }
            break;
        case 'clear':
            search.docType = '';
            search.conditionsRequests = [];
            break;
        default:
            break;
    }

    yield put({
        type: SET_SEARCH,
        payload: search,
    });
}

function* selectTemplate(action) {
    try {
        yield put({
            type: SET_SELECT_TEMPLATE_BOX,
            payload: {
                selectTemplateBox: {
                    isShow: true,
                },
            },
        });
    } catch (error) {
        console.warn('selectTemplate', error);
    } 

}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_SEARCH:
            const newState = produce(state, (draft) => {
                Object.entries(action.payload).forEach(([key, value]) => {
                    draft[key] = action.payload[key];
                });
            });
            return newState;
        case SET_SELECT_TEMPLATE_BOX:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};

export function* watchSearch() {
    yield takeEvery(GET_SEARCH_LIST, safeSaga(getSearchList));
    yield takeEvery(SET_SEARCH_DATA, safeSaga(setSearchData));
    yield takeEvery(UPDATE_SEARCH_CONDITIONS, safeSaga(updateSearchConditions));
    yield takeEvery(SHOW_SELECT_TEMPLATE_BOX, safeSaga(selectTemplate));
}

export default reducer;
